import { render, staticRenderFns } from "./Tag.pug?vue&type=template&id=9c70225c&scoped=true&lang=pug&functional=true&"
import script from "./Tag.vue?vue&type=script&lang=js&"
export * from "./Tag.vue?vue&type=script&lang=js&"
import style0 from "./Tag.scss?vue&type=style&index=0&id=9c70225c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "9c70225c",
  null
  
)

export default component.exports